<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-18 11:03:39
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-18 11:41:57
 -->
<!--  -->
<template>
  <div class="localTable">
      <easyCruds
      :tableInfo="extTable"
      @addExtRow="addExtRow"
      @Edit="Edit"
      @deleteExtRows="deleteExtRows"

       />
  </div>
</template>

<script>
import easyCruds from '@/framework/components/baseComponent/easyCrud/easyCruds.vue'
export default {
  data() {
    return {
      extTable: {
        header: { title: '扩展字段' },
        buttonSetting: {
          allowRefresh: false,
          /** 是否允许新增按钮 */
          allowAdd: this.allowModify,
          addText: '新增扩展字段',
          addCloseOnClickModal: true,
          addButtonArray: [{
            clickEvent: 'addExtRow',
            type: 'primary',
            buttonName: '新增',
            validate: true
          }],
          /** 是否允许编辑按钮 */
          allowEdit: this.allowModify,
          editText: '编辑扩展字段',
          editCloseOnClickModal: true,
          editButtonArray: [{
            clickEvent: 'Edit',
            type: 'primary',
            buttonName: '保存编辑',
            validate: true
          }],
          /** 是否允许删除按钮 */
          allowDelete: this.allowModify,
          deleteFunctionName: 'deleteExtRows',
          /** 是否允许查看按钮 */
          allowView: true,
          viewText: '查看扩展字段',
          viewCloseOnClickModal: true
        }, table: {
          loading: false,
          maxHeight: 300,
          stripe: true,
          columns: [{
            prop: 'extPropertyKey',
            label: '字段名',
            type: 'input',
            maxlength: 500,
            span: 23,
            disabled: [false, true, true],
            required: true
          }, {
            prop: 'extPropertyValue',
            label: '字段值',
            type: 'input',
            maxlength: 500,
            span: 23,
            required: true
          }, {
            prop: 'description',
            label: '字段描述',
            maxlength: 1500,
            span: 23,
            type: 'textarea',
            minRows: 5,
            maxRows: 10
          }],
          operation: {
            width: '220'
          },
          tableData: this.data,
          reloadConditions: {

          },
          addDefultValue: {

          }
        }
      }
    }
  },

  components: { easyCruds },
  props: ['data', 'allowModify'],
  watch: {
    allowModify: function(val) {
      this.extTable.buttonSetting.allowAdd = val
      this.extTable.buttonSetting.allowEdit = val
      this.extTable.buttonSetting.allowDelete = val
    }

  },
  methods: {
    setData: function(data) {
      this.$set(this.extTable, 'tableData', data || [])
    },
    getData: function() {
      return this.extTable.tableData || []
    },
    setAllowAddAndDelete: function(add, del) {
      this.extTable.buttonSetting.allowAdd = add
      this.extTable.buttonSetting.allowDelete = del
    },
    /** 新增加扩展字段函数 */
    addExtRow: function(params, done, erroeDone) {
      if (this.extTable.table.tableData.some(item => item.extPropertyKey === params.extPropertyKey)) {
        return this.$message.error('字段名称重复') && erroeDone()
      } else {
        this.extTable.table.tableData.push(params) && done()
      }
    },
    Edit: function(params, done, erroeDone) {
      this.data.forEach(item => {
        if (item.extPropertyKey === params.extPropertyKey) {
          this.$set(item, 'extPropertyValue', params.extPropertyValue)
          this.$set(item, 'description', params.description)
        }
      })
      done()
    },
    /** 删除扩展字段 */
    deleteExtRows: function(deleteList) {
      let extPropertyKeyList = []
      deleteList.forEach((items) => {
        extPropertyKeyList.push(items.extPropertyKey)
      })
      let result = this.extTable.table.tableData.filter(item => !extPropertyKeyList.includes(item.extPropertyKey))
      this.data.splice(0, this.data.length)
      result.forEach(item => this.data.push(item))
    }
  }
}

</script>
<style lang='scss' scoped>
</style>
